export const FILTER_CONFIG = {
  lastSearch: '00:00',
  groups: [
    {
      id: 'quick_search',
      label: 'Quick search',
      type: 'open',
    },
    {
      id: 'services-for',
      label: 'Filter results',
      type: 'dropdown',
    },
    {
      id: 'location',
      label: 'Location',
      type: 'dropdown',
    },
    /*
    {
      id: 'availability',
      label: 'Availability',
      type: 'dropdown',
    },
    */
  ],
  filterSettings: [
    /*
    {
      label: 'Needs',
      placeholder: 'Needs',
      paramId: 'need',
      apiParamName: 'esdNeeds',
      filterType: 'versatile-filter',
      filterData: [
        { id: '9', name: 'Financial support' },
        { id: '111', name: 'Emotional wellbeing' },
        { id: '95', name: 'Evening classes' },
        { id: '27', name: 'Better health' },
        { id: '103', name: 'Disabilities and special needs support' },
        { id: '97', name: 'Special educational needs (SEN)' },
        { id: '113', name: 'Losing weight/Healthy eating' },
        { id: '67', name: 'Sports and physical activity' },
        { id: '71', name: 'Community facilities' },
        { id: '115', name: 'Hobbies and interests' },
        { id: '36', name: 'Improving mental health' },
        { id: '68', name: 'Open spaces' },
        { id: '105', name: 'Youth support' },
        { id: '80', name: 'Child care' },
        { id: '104', name: 'Parenting support' },
      ],
      selected: [],
      group: 'services-for',
    },
    {
      label: 'Circumstances',
      placeholder: 'Circumstances',
      paramId: 'circumstance',
      apiParamName: 'esdCircumstances',
      filterType: 'versatile-filter',
      filterData: [
        { id: 'FinancialDifficulties', name: 'Financial difficulties' },
        { id: 'Employmentstatus_Unemployed', name: 'Unemployed' },
        { id: 'Disabled', name: 'Disabled' },
        { id: 'Lonely', name: 'Lonely' },
        { id: 'ObeseOverweight', name: 'Obese or overweight' },
        { id: 'Employmentstatus_Retired', name: 'Retired' },
      ],
      selected: [],
      group: 'services-for',
    },
    */
    {
      label: 'Service types',
      placeholder: "I'm interested in",
      paramId: 'service_type',
      apiParamName: 'esdServiceTypes',
      filterType: 'versatile-filter',
      filterData: [
        { id: '1688', name: 'Health and wellbeing' },
        { id: '451', name: 'Sports facilities' },
        { id: '1789', name: 'Exercise and fitness classes ' },
        { id: '241', name: 'Inclusive leisure and social activities' },
        { id: '640', name: 'Activities for older people' },
        { id: '885', name: 'Sports development' },
        { id: '1674', name: 'Swimming pools' },
        { id: '1793', name: 'Outdoor activities' },
        { id: '453', name: 'Sports coaching' },
        { id: '349', name: 'Business advice' },
        { id: '297', name: 'Community support groups and organisations' },
        { id: '448', name: 'Archives' },
        { id: '1579', name: 'Family information services' },
        { id: '18', name: 'School holiday schemes' },
        { id: '12', name: 'Nursery school places' },
        { id: '1741', name: 'Early education for 2 year olds' },
        { id: '20', name: 'Childminding' },
        { id: '1680', name: 'Childcare sufficiency assessment' },
        { id: '19', name: 'Childcare out of school hours' },
        { id: '190', name: 'Benefits advice and assessment' },
        { id: '437', name: 'Library facilities' },
        { id: '1806', name: 'Social clubs and groups' },
        { id: '1601', name: 'Bookstart' },
        { id: '676', name: 'Legal advice' },
        { id: '336', name: 'Municipal golf courses' },
        { id: '642', name: 'Young peoples drop in activities' },
        { id: '1141', name: 'Library loans' },
        { id: '1794', name: 'Skills for living' },
        { id: '643', name: 'Young peoples organised activities' },
        { id: '1807', name: 'Health support groups and organisations' },
        { id: '1803', name: 'Alternative therapies and treatments' },
        { id: '620', name: 'Museums and galleries' },
      ],
      selected: [],
      group: 'services-for',
    },
    /*
    {
      label: 'Age Group',
      placeholder: 'Age',
      paramId: 'minimum_age',
      filterType: 'versatile-filter',
      filterData: [
        {
          id: 'allAges',
          name: 'All ages',
          queryValues: { minimum_age: 0, maximum_age: 120 },
        },
        {
          id: 'youPeople',
          name: 'Young People',
          queryValues: { minimum_age: 0, maximum_age: 18 },
        },
        {
          id: 'oldPeople',
          name: 'Old People',
          queryValues: { minimum_age: 50, maximum_age: 120 },
        },
      ],
      selected: [],
      group: 'filters',
    },
    {
      label: 'Postcode',
      placeholder: 'Enter postcode',
      paramId: 'postcode',
      filterType: 'versatile-filter',
      filterData: '',
      selected: [],
      group: 'location',
      lozengerCombine: 'proximity',
    },
    {
      label: 'Postcode radius',
      placeholder: 'Postcode radius',
      paramId: 'proximity',
      filterType: 'versatile-filter',
      dependent: 'postcode',
      filterData: [
        { id: 10000, name: '10 km' },
        { id: 9000, name: '9 km' },
        { id: 8000, name: '8 km' },
        { id: 7000, name: '7 km' },
        { id: 6000, name: '6 km' },
        { id: 5000, name: '5 km' },
        { id: 4000, name: '4 km' },
        { id: 3000, name: '3 km' },
        { id: 2000, name: '2 km' },
        { id: 1000, name: '1 km' },
      ],
      selected: [],
      group: 'location',
      lozengerIgnore: true,
      lozengerCombineLabel: 'Radius',
    },
    {
      label: 'when',
      placeholder: 'Days',
      paramId: 'When',
      filterType: 'dayTime',
      filterData: {
        id: 'JSON.stringify(this.$store.state.timeOfDayMap) + JSON.stringify(this.$store.state.dayMap)',
      },
      selected: [],
      filterRule: 'dayTime',
    },
    {
      label: 'Time of day',
      placeholder: 'Time',
      paramId: 'start_time',
      filterType: 'versatile-filter',
      filterData: [
        {
          id: 'am',
          name: 'AM',
          queryValues: { start_time: '00:00', end_time: '12:00' },
        },
        {
          id: 'pm',
          name: 'PM',
          queryValues: { start_time: '12:00', end_time: '17:30' },
        },
        {
          id: 'evening',
          name: 'Evening',
          queryValues: { start_time: '17:30', end_time: '11:59' },
        },
      ],
      selected: [],
      group: 'availability',
    },
    // Safe param name the -safe is striped from param name.
    {
      label: 'Day',
      placeholder: 'Days',
      paramId: 'day-safe',
      filterType: 'versatile-filter',
      filterData: [
        {
          id: 'MO',
          name: 'Monday',
        },
        {
          id: 'TU',
          name: 'Tuesday',
        },
        {
          id: 'WE',
          name: 'Wednesday',
        },
        {
          id: 'TH',
          name: 'Thursday',
        },
        {
          id: 'FR',
          name: 'Friday',
        },
        {
          id: 'SA',
          name: 'Saturday',
        },
        {
          id: 'SU',
          name: 'Sunday',
        },
      ],
      selected: [],
      group: 'availability',
    },
    {
      label: 'Age Group',
      paramId: 'minimum_age',
      filterType: 'versatile-filter',
      filterData: [
        {
          id: 'allAges',
          name: 'All ages',
          queryValues: { minimum_age: 0, maximum_age: 120 },
        },
        {
          id: 'youPeople',
          name: 'Young People',
          queryValues: { minimum_age: 0, maximum_age: 18 },
        },
        {
          id: 'oldPeople',
          name: 'Old People',
          queryValues: { minimum_age: 50, maximum_age: 120 },
        },
      ],
      selected: [],
      group: 'for',
    },
    */
    {
      label: 'Text',
      paramId: 'text',
      placeholder: 'Search to find a service...',
      filterType: 'versatile-filter',
      filterData: '',
      selected: [],
      group: 'quick_search',
    },
    {
      label: 'Counties',
      placeholder: 'County',
      paramId: 'counties',
      filterType: 'versatile-filter',
      filterData: [
        { name: 'Bristol', id: 'Bristol' },
        { name: 'South Gloucestershire', id: 'South Gloucestershire' },
      ],
      selected: [],
      group: 'location',
      ignore: true,
    },
    {
      label: 'Region',
      placeholder: 'Region',
      paramId: 'coverage',
      dependent: 'counties',
      filterType: 'versatile-filter',
      filterData: [],
      denpdencyData: {
        Bristol: [
          { id: 'Central Bristol', name: 'Central Bristol' },
          { id: 'Clifton', name: 'Clifton' },
          { id: 'Hotwells', name: 'Hotwells' },
          { id: 'Montpelier', name: 'Montpelier' },
          { id: 'Old Market', name: 'Old Market' },
          { id: 'Redcliffe', name: 'Redcliffe' },
          { id: 'St Pauls', name: 'St Pauls' },
          { id: 'St Philips', name: 'St Philips' },
          { id: 'Stokes Croft', name: 'Stokes Croft' },
          { id: 'The Centre', name: 'The Centre' },
          { id: 'East Bristol', name: 'East Bristol' },
          { id: 'Barton Hill', name: 'Barton Hill' },
          { id: 'Easton', name: 'Easton' },
          { id: 'Eastville', name: 'Eastville' },
          { id: 'Fishponds', name: 'Fishponds' },
          { id: 'Hillfields', name: 'Hillfields' },
          { id: 'Lawrence Hill', name: 'Lawrence Hill' },
          { id: 'Redfield', name: 'Redfield' },
          { id: 'Speedwell', name: 'Speedwell' },
          { id: 'St George', name: 'St George' },
          { id: "St Werburgh's", name: "St Werburgh's" },
          { id: 'Stapleton', name: 'Stapleton' },
          { id: 'Whitehall', name: 'Whitehall' },
          { id: 'North Bristol', name: 'North Bristol' },
          { id: 'Bishopston', name: 'Bishopston' },
          { id: 'Cotham', name: 'Cotham' },
          { id: 'Henleaze', name: 'Henleaze' },
          { id: 'Horfield', name: 'Horfield' },
          { id: 'Kingsdown', name: 'Kingsdown' },
          { id: 'Lockleaze', name: 'Lockleaze' },
          { id: 'Redland', name: 'Redland' },
          { id: 'Southmead', name: 'Southmead' },
          { id: 'St Andrews', name: 'St Andrews' },
          { id: 'Westbury on Trym', name: 'Westbury on Trym' },
          { id: 'North West Bristol', name: 'North West Bristol' },
          { id: 'Avonmouth', name: 'Avonmouth' },
          { id: 'Brentry', name: 'Brentry' },
          { id: 'Henbury', name: 'Henbury' },
          { id: 'Kingsweston', name: 'Kingsweston' },
          { id: 'Lawrence Weston', name: 'Lawrence Weston' },
          { id: 'Sea Mills', name: 'Sea Mills' },
          { id: 'Shirehampton', name: 'Shirehampton' },
          { id: 'Stoke Bishop', name: 'Stoke Bishop' },
          { id: 'South Bristol', name: 'South Bristol' },
          { id: 'Ashton', name: 'Ashton' },
          { id: 'Bedminster', name: 'Bedminster' },
          { id: 'Bishopsworth', name: 'Bishopsworth' },
          { id: 'Brislington', name: 'Brislington' },
          { id: 'Filwood Park', name: 'Filwood Park' },
          { id: 'Hartcliffe', name: 'Hartcliffe' },
          { id: 'Hengrove', name: 'Hengrove' },
          { id: 'Highridge', name: 'Highridge' },
          { id: 'Knowle', name: 'Knowle' },
          { id: 'Knowle West', name: 'Knowle West' },
          { id: 'Southville', name: 'Southville' },
          { id: "St Anne's", name: "St Anne's" },
          { id: 'Stockwood', name: 'Stockwood' },
          { id: 'Totterdown', name: 'Totterdown' },
          { id: 'Whitchurch', name: 'Whitchurch' },
          { id: 'Windmill Hill', name: 'Windmill Hill' },
          { id: 'Withywood', name: 'Withywood' },
        ],
        'South Gloucestershire': [
          { id: 'Almondsbury', name: 'Almondsbury' },
          { id: 'Alveston', name: 'Alveston' },
          { id: 'Bitton', name: 'Bitton' },
          { id: 'Bradley Stoke', name: 'Bradley Stoke' },
          { id: 'Bromley Heath', name: 'Bromley Heath' },
          { id: 'Cadbury Heath', name: 'Cadbury Heath' },
          { id: 'Chipping Sodbury', name: 'Chipping Sodbury' },
          { id: 'Coalpit Heath', name: 'Coalpit Heath' },
          { id: 'Downend', name: 'Downend' },
          { id: 'Easter Compton', name: 'Easter Compton' },
          { id: 'Emersons Green', name: 'Emersons Green' },
          { id: 'Filton', name: 'Filton' },
          { id: 'Frampton Cotterell', name: 'Frampton Cotterell' },
          { id: 'Frenchay', name: 'Frenchay' },
          { id: 'Hanham', name: 'Hanham' },
          { id: 'Iron Acton', name: 'Iron Acton' },
          { id: 'Kingswood', name: 'Kingswood' },
          { id: 'Little Stoke', name: 'Little Stoke' },
          { id: 'Longwell Green', name: 'Longwell Green' },
          { id: 'Lyde Green', name: 'Lyde Green' },
          { id: 'Mangotsfield', name: 'Mangotsfield' },
          { id: 'North Common', name: 'North Common' },
          { id: 'Old Sodbury', name: 'Old Sodbury' },
          { id: 'Oldbury-on-Severn', name: 'Oldbury-on-Severn' },
          { id: 'Oldland Common', name: 'Oldland Common' },
          { id: 'Patchway', name: 'Patchway' },
          { id: 'Pilning', name: 'Pilning' },
          { id: 'Pucklechurch', name: 'Pucklechurch' },
          { id: 'Rangeworthy', name: 'Rangeworthy' },
          { id: 'Severn Beach', name: 'Severn Beach' },
          { id: 'Soundwell', name: 'Soundwell' },
          { id: 'Staple Hill', name: 'Staple Hill' },
          { id: 'Stoke Gifford', name: 'Stoke Gifford' },
          { id: 'Thornbury', name: 'Thornbury' },
          { id: 'Tockington', name: 'Tockington' },
          { id: 'Warmley', name: 'Warmley' },
          { id: 'Westerleigh', name: 'Westerleigh' },
          { id: 'Wick', name: 'Wick' },
          { id: 'Winterbourne', name: 'Winterbourne' },
          { id: 'Winterbourne Down', name: 'Winterbourne Down' },
          { id: 'Wotton-under-Edge', name: 'Wotton-under-Edge' },
          { id: 'Yate', name: 'Yate' },
        ],
      },
      selected: [],
      group: 'location',
    },
  ],
}

export default FILTER_CONFIG
